export default "/react/logoReviewLab-c622cfd7.png";